import { useAuth } from "@/contexts/AuthContext";

export interface TenantIdentity {
  /** Identificador del tenant emitido por TGT One (JWT). */
  tenantId: string | null;
  /** Razón social del tenant según TGT One. Sólo lectura en esta app. */
  tenantName: string | null;
  loading: boolean;
}

/**
 * Fuente única de identidad del tenant en el frontend.
 *
 * Los datos provienen exclusivamente de la sesión del login central (TGT One)
 * y no pueden modificarse desde esta aplicación. El sistema opera en modo
 * single-tenant por instancia: no existe selector de empresa.
 */
export function useTenant(): TenantIdentity {
  const { session, loading } = useAuth();
  return {
    tenantId: session?.tenantId ?? session?.user?.tenantId ?? null,
    tenantName: session?.tenantName ?? session?.user?.tenantName ?? null,
    loading,
  };
}
